import { useEffect, useState } from "react";
import { Association } from "src/interfaces/Common";
import { PagesID } from "@utils/utilsConfigurations";
import { ServicesURL } from "@utils/utilsApi";
import { useParams } from "react-router-dom";

export const useAddEditCostProject = (dataDetail?: any) => {
  const { idProject } = useParams();
  const [openAssociations, setOpenAssociations] = useState<
    boolean | Association
  >(false);
  const [supplierAssociation, setSupplierAssociation] = useState<any>([]);
  const [categoryAssociation, setCategoryAssociation] = useState<any>([]);
  const [contractAssociation, setContractAssociation] = useState<any>([]);

  const formatSupplier = (supplier: any) => {
    supplier.label = supplier.business_name;
    setSupplierAssociation([supplier]);
  };

  const formatCategory = (category: any) => {
    category.label = category.business_name;
    setCategoryAssociation([category]);
  };

  const formatContract = (contract: any) => {
    contract.label = contract.sap_code;
    setContractAssociation([contract]);
  };

  const resetCostProjectAssociations = () => {
    if (dataDetail?.supplier) {
      formatSupplier(dataDetail.supplier);
    } else {
      setSupplierAssociation([]);
    }

    if (dataDetail?.budget_project_categorization) {
      formatCategory(dataDetail.budget_project_categorization);
    } else {
      setCategoryAssociation([]);
    }

    if (dataDetail?.contract) {
      formatContract(dataDetail.contract);
    } else {
      setContractAssociation([]);
    }
  };

  useEffect(() => {
    if (dataDetail?.contract?.supplier) {
      formatSupplier(dataDetail.contract.supplier);
    }

    if (dataDetail?.budget_project_categorization) {
      formatCategory(dataDetail.budget_project_categorization);
    }

    if (dataDetail?.contract) {
      formatContract(dataDetail.contract);
    }
  }, [dataDetail]);

  const setOpenAssociation = (
    accessorKey: string,
    value: boolean,
    inputForm: any,
  ) => {
    switch (accessorKey) {
      case "supplier":
        setOpenAssociations(
          value
            ? {
                accessorKey: "supplier",
                mediaType: "supplier",
                type: "table",
                titleKey: "supplier-association",
                pageId: PagesID["suppliers"],
                service: ServicesURL.getSuppliers,
                multiChoice: false,
              }
            : value,
        );
        break;
      case "budget_project_categorization":
        let internal = inputForm?.internal;
        setOpenAssociations(
          value
            ? {
                accessorKey: "budget_project_categorization",
                mediaType: "budget_project_categorization",
                type: "table",
                titleKey: "categorization-association",
                pageId: PagesID["projects.categorizations.categories-cost"],
                service:
                  ServicesURL.getProjectsCategorizations.replace(
                    ":budgetProjectId",
                    idProject || "",
                  ) +
                  "?internal=" +
                  internal,
                multiChoice: false,
              }
            : value,
        );
        break;
      case "contract":
        setOpenAssociations(
          value
            ? {
                accessorKey: "contract",
                mediaType: "contract",
                type: "table",
                titleKey: "contract-association",
                pageId: PagesID["contracts"],
                service: ServicesURL.getContracts,
                defaultFilters: {
                  supplier:
                    supplierAssociation && supplierAssociation[0]
                      ? supplierAssociation[0]?.id
                      : undefined,
                },
                multiChoice: false,
              }
            : value,
        );
        break;
    }
  };

  const getValues = (accessorKey: string) => {
    switch (accessorKey) {
      case "supplier":
        return supplierAssociation;
      case "budget_project_categorization":
        return categoryAssociation;
      case "contract":
        return contractAssociation;
    }
  };

  const handleDelete = (accessorKey: string, e: any) => {
    switch (accessorKey) {
      case "supplier":
        setSupplierAssociation(
          supplierAssociation.filter((element: any) => element.id !== e.id),
        );
        setContractAssociation([]);
        break;
      case "budget_project_categorization":
        setCategoryAssociation(
          categoryAssociation.filter((element: any) => element.id !== e.id),
        );
        setContractAssociation([]);
        setSupplierAssociation([]);
        break;
      case "contract":
        setContractAssociation(
          contractAssociation.filter((element: any) => element.id !== e.id),
        );
        break;
    }
  };

  const handleAssociation = (accessorKey: string, value: any) => {
    switch (accessorKey) {
      case "supplier":
        const objToSupplierAssociation: any = Object.keys(value).map(
          (key: string) => {
            if (key.includes("||")) {
              return {
                id: key.split("||")[0],
                label: key.split("||")[1],
              };
            } else {
              return supplierAssociation.find((elem: any) => elem.id === +key);
            }
          },
        );
        setSupplierAssociation(objToSupplierAssociation);
        break;
      case "budget_project_categorization":
        const objToCategoryAssociation: any = Object.keys(value).map(
          (key: string) => {
            if (key.includes("||")) {
              return {
                id: key.split("||")[0],
                label: key.split("||")[1],
                available_budget: key.split("||")[2],
              };
            } else {
              return categoryAssociation.find((elem: any) => elem.id === +key);
            }
          },
        );
        setCategoryAssociation(objToCategoryAssociation);
        break;
      case "contract":
        const objToContractAssociation: any = Object.keys(value).map(
          (key: string) => {
            if (key.includes("||")) {
              return {
                id: key.split("||")[0],
                label: key.split("||")[1],
              };
            } else {
              return contractAssociation.find((elem: any) => elem.id === +key);
            }
          },
        );
        setContractAssociation(objToContractAssociation);
        break;
    }
  };

  return {
    handleAssociation,
    setOpenAssociation,
    handleDelete,
    getValues,
    resetCostProjectAssociations,
    setSupplierAssociation,
    setCategoryAssociation,
    setContractAssociation,
    supplierAssociation,
    categoryAssociation,
    contractAssociation,
    openAssociations,
  };
};
